import { useState } from 'react';

/** The built-in logo, shown until the hotel uploads its own (and if the uploaded one cannot be loaded). */
export const BUILT_IN_LOGO = '/icons/logo-96.png';

/**
 * The hotel's logo. `version` comes from the server and changes with every upload, so a new logo shows at once:
 * a number means "the hotel has uploaded one"; null means "it has not"; undefined means "not known yet" (the sign-in page),
 * which tries the uploaded logo and quietly falls back to the built-in one.
 */
export function HotelLogo({ version, className, size, alt = '' }: { version?: number | null; className?: string; size?: number; alt?: string }) {
  const [failed, setFailed] = useState(false);
  const custom = version !== null && !failed;
  const src = custom ? `/api/public/logo${version ? `?v=${version}` : ''}` : BUILT_IN_LOGO;
  return <img src={src} alt={alt} className={className} {...(size ? { width: size, height: size } : {})} onError={() => setFailed(true)} />;
}
